<template>
  <v-menu
    ref="menu"
    v-model="showMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateFormatted"
        :label="label"
        :hint="hideHint ? null : 'DD.MM.YYYY (z.B. 15.03.2023)'"
        :persistent-hint="!hideHint"
        prepend-icon="mdi-calendar"
        clearable
        v-bind="attrs"
        v-on="on"
        :disabled="disabled"
        @blur="onDateFormattedChange(dateFormatted)"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      @change="onDateChange"
      no-title
      scrollable
      :disabled="disabled"
    >
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment/moment"

export default {
  name: 'TextFieldDatePicker',
  props: {
    label: {
      type: String,
      default: 'Select Date'
    },
    useFallBackDate: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideHint: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      date: null,
      dateFormatted: null,
      showMenu: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newValue) {
        if (newValue) {
          if (newValue.includes('-')) {
            this.date = newValue.split('T')[0]
            this.dateFormatted = this.formatIsoDate(newValue)
          } else {
            this.dateFormatted = newValue
            this.date = this.parseDate(newValue)
          }
        } else {
          this.date = null
          this.dateFormatted = null
        }
      }
    }
  },
  mounted () {
    if (!this.value && this.useFallBackDate) {
      const startOfLastYear = moment()
        .subtract(1, 'year')
        .startOf('year')

      this.date = startOfLastYear.format('YYYY-MM-DD')
      this.dateFormatted = this.formatIsoDate(this.date)
      this.$emit('input', this.date)
    }
  },
  methods: {
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('.').map(Number)
      return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`
    },
    formatIsoDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('T')[0].split('-').map(Number)
      return `${day.toString().padStart(2, '0')}.${month.toString().padStart(2, '0')}.${year}`
    },
    onDateChange (newDate) {
      this.dateFormatted = this.formatIsoDate(newDate)
      this.$emit('input', newDate)
      this.showMenu = false
    },
    onDateFormattedChange (newDate) {
      this.date = this.parseDate(newDate)
      this.$emit('input', this.date)
    }
  },
}
</script>
